import PropTypes from 'prop-types'

import { Error } from './Icons'

const SweetAlertError = ({ icon, message, subMessage }: any) => (
  <div className="f-modal-alert flex-center">
    {icon}

    <div className="message">
      <span className="error-header">{message}</span>
      <p className="error-sub-header">{subMessage}</p>
    </div>
  </div>
)

SweetAlertError.displayName = 'SweetAlertError'

SweetAlertError.propTypes = {
  icon: PropTypes.element,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  subMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
}

SweetAlertError.defaultProps = {
  icon: <Error />,
  message: '',
  subMessage: ''
}

export default SweetAlertError
